export default __webpack_public_path__ + "static/media/message-list.8203afd6.jpg";